import { Component, inject } from "@angular/core";
import { AuthenticationService } from "@app/services/authentication.service";
import { CustomerType } from "@app/models/customer/customer-type.enum";
import { Router, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
   selector: "my-cloud-navigation",
   templateUrl: "./navigation.component.html",
   styleUrls: ["./navigation.component.scss"],
   imports: [RouterLink, TranslatePipe]
})
export class NavigationComponent {
   private router = inject(Router);
   authService = inject(AuthenticationService);

   public get customerIsPartner(): boolean {
      return this.authService.customerType == CustomerType.Partner;
   }

   public get activeRoute(): string {
      return this.router.url;
   }
}
